import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  //  language: null,
  sortby: null,
  wrapperSize: 0,
  enableSound: null,
  isMobile: /Mobi|Android/i.test(navigator.userAgent),
  sessionExpired: false,
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
